import { render, staticRenderFns } from "./NewMonthTitle.vue?vue&type=template&id=50158944&scoped=true&"
import script from "./NewMonthTitle.vue?vue&type=script&lang=ts&"
export * from "./NewMonthTitle.vue?vue&type=script&lang=ts&"
import style0 from "./NewMonthTitle.vue?vue&type=style&index=0&id=50158944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50158944",
  null
  
)

export default component.exports